var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "ob1-snackbar over-page-loading-spinner",
      attrs: {
        id: _vm.id,
        role: "status",
        "aria-live": "polite",
        "aria-atomic": "true",
        "data-ob1-component": "Snackbar",
      },
    },
    [
      _c("div", { staticClass: "ob1-snackbar-wrapper" }, [
        _c("span", {
          staticClass: "ob1-snackbar-icon",
          class: _vm.displayedIcon,
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c("p", {
          staticClass: "ob1-snackbar-label",
          domProps: { textContent: _vm._s(_vm.displayedMessage) },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }